<template>
  <div class="design-form">
    <!-- 找设计发布 -->
    <el-form
      ref="designRuleForm"
      :model="designRuleForm"
      :rules="rules"
      label-width="136px"
      class="demo-designRuleForm"
    >
      <el-form-item label="项目名称：" prop="reqName">
        <el-input
          v-model="designRuleForm.reqName"
          placeholder="请输入名称(1~30字符)"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目所在地：" prop="reqAddr">
        <el-cascader
          v-model="designRuleForm.reqAddr"
          :options="areaData"
          size="large"
          placeholder="请选择省/市/区"
          style="width: 100%"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址：" prop="address">
        <el-input v-model="designRuleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="交付时间：" prop="reqEndtime">
        <el-date-picker
          v-model="designRuleForm.reqEndtime"
          type="date"
          placeholder="请选择日期(例如:2021-08-12)"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          style="width: 100%;"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="订单类型：" prop="lightSteelStructureType">
        <el-select
          v-model="designRuleForm.lightSteelStructureType"
          placeholder="请选择类型"
          style="width: 100%"
        >
          <el-option
            v-for="(item, index) in unitList"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <div class="lflex total-budget">
        <el-form-item label="建筑总面积：" prop="constructionSpace">
          <el-input
            v-model="designRuleForm.constructionSpace"
            placeholder="请输入数字"
          >
          </el-input>
        </el-form-item>
        <span class="unit">㎡</span>
      </div>
      <el-form-item label="设计要求：" prop="designRequire">
        <el-input
          v-model="designRuleForm.designRequire"
          type="textarea"
          placeholder="请输入描述"
          maxlength="500"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="包含服务：" prop="servicesInclude">
        <el-checkbox-group v-model="designRuleForm.servicesInclude">
          <el-checkbox
            v-for="(item, index) in serviceList"
            :key="index"
            :label="item"
            style="width: 24%"
          ></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="图片：">
        <el-upload
          action="/cms/images/upload.do"
          list-type="picture-card"
          :limit="6"
          :file-list="fileList"
          :http-request="handleUpload"
          :before-upload="beforeUpload"
          :on-remove="handleRemove"
          :on-exceed="handleExceed"
          :on-preview="handlePictureCardPreview"
        >
          <i class="el-icon-plus"></i>
          <div slot="tip" class="upload-tips">
            上传格式包含但不限于：jpg、jpeg、gif、png、bmp、图片各种格式,
            单个图片不要大于10m
          </div>
        </el-upload>

        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </el-form-item>
      <el-form-item label="联系人：" prop="linkmanName">
        <el-input
          v-model="designRuleForm.linkmanName"
          placeholder="请输入联系人(1~10字符)"
          maxlength="10"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人手机号：" prop="linkmanMobile">
        <el-input
          v-model="designRuleForm.linkmanMobile"
          placeholder="请输入联系手机号"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button class="sub-btn save-btn" @click="submitForm('save')">
          保存草稿
        </el-button>
        <el-button class="sub-btn" type="primary" @click="submitForm('submit')">
          提交
        </el-button>
      </el-form-item>
    </el-form>
    <!-- 需求显示确认弹框弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      class="demandPopup"
      :close-on-click-modal="false"
    >
      <p class="tCenter">
        提交成功
      </p>
      <div class="one font18 fontW">
        您的需求已提交成功，平台会在1-3个工作日后审核
      </div>

      <div class="btn_group tCenter">
        <el-button class="btn_sure" @click="toDemandHall">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const serviceList = [
  '总平面规划方案',
  '效果图',
  '建筑施工图',
  '给排水施工',
  '税费',
  '建筑单体方',
  '规划文本',
  '钢结构施工图',
  '电气施工图'
]
const unitList = [
  '厂房',
  '仓库',
  '夹层',
  '露面夹层',
  '楼梯',
  '加油站',
  '展厅',
  '雨棚',
  '广告牌',
  '门头造型',
  '景观造型',
  '隔音屏',
  '护栏',
  '异形件',
  '幕墙',
  '轻钢构件',
  '其他'
]
export default {
  name: 'DesignForm',
  data() {
    // 验证手机号
    var checkMobile = (rule, value, cb) => {
      const regMobile = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
      if (regMobile.test(value)) {
        // 合法手机
        return cb()
      }
      cb(new Error('请输入正确的手机号'))
    }
    // 项目总面积, 验证用户输入是否为数字
    var totalBudget = (rule, value, cb) => {
      const reg = new RegExp('^[1-9]*[1-9][0-9]*$')
      if (reg.test(value) && value < 99999999) {
        return cb()
      }
      cb(new Error('请输入正整数'))
    }
    return {
      isEdit: false,
      serviceList: serviceList,
      options: [],
      designRuleForm: {
        reqName: '', // 项目名称
        reqAddr: '', // 项目所在地
        address: '', // 详细地址
        reqEndtime: '', // 交付时间
        lightSteelStructureType: '', // 订单类型
        constructionSpace: '', // 建筑总面积
        designRequire: '', // 设计要求
        servicesInclude: [], // 包含服务
        reqFileList: [], // 图片/需求附件
        linkmanName: '', // 联系人
        linkmanMobile: '' // 联系人手机号
      },
      unitList: unitList,
      dialogImageUrl: '',
      dialogVisible: false,
      dialogVisible2: false,
      rules: {
        reqName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' },
          { min: 1, max: 30, message: '1~30个字符', trigger: 'blur' }
        ],
        reqAddr: [
          { required: true, message: '请选择省/市/区', trigger: 'change' }
        ],
        reqEndtime: [
          { required: true, message: '请选择时间', trigger: 'blur' }
        ],
        lightSteelStructureType: [
          { required: true, message: '请选择订单类型', trigger: 'change' }
        ],
        designRequire: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        servicesInclude: [
          { required: true, message: '请选择服务', trigger: 'change' }
        ],
        constructionSpace: [
          { required: true, message: '请输入数字', trigger: 'blur' },
          {
            validator: totalBudget,
            message: '请输入数字',
            trigger: 'blur'
          }
        ],
        linkmanName: [
          { required: true, message: '请输入联系人', trigger: 'blur' },
          { min: 1, max: 10, message: '1~10个字符', trigger: 'blur' }
        ],
        linkmanMobile: [
          { required: true, message: '请输入联系人手机号', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ]
      },
      imageList: [],
      // 日期选择范围在一个月内
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      fileList: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.login.userInfo
    }),
    areaData() {
      return this.$store.getters.areaData
    }
  },
  created() {
    // console.log(this.userInfo)
    let demandId = this.$route.query.id
    if (demandId && demandId !== '') {
      this.queryDetail(demandId)
    }
  },
  methods: {
    // 查询需求详情
    queryDetail(id) {
      this.$http
        .post(`/cms/reqDesign/findReqVoById/${id}`, { viewindex: 0 })
        .then(res => {
          if (res.data.code === '000000') {
            this.isEdit = true
            let result = res.data.result
            result.reqAddr = [result.province, result.city, result.district]
            result.servicesInclude = result.servicesInclude.split(',')
            this.designRuleForm = result
            result.reqFileList.map(item => {
              this.fileList.push({
                url: item.reqFileName
              })
            })
          }
        })
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    handleUpload(file) {
      const formData = new FormData()
      formData.append('imgFile', file.file)
      this.$http.post('/cms/reqFile/upload', formData).then(res => {
        if (res.data.code === '000000') {
          this.designRuleForm.reqFileList.push({
            reqFileName: res.data.result
          })
          this.imageList.push(file.file.name)
        }
      })
    },
    beforeUpload(file) {
      // 对已经上传过的图片不处理
      if (this.imageList.includes(file.name)) {
        return false
      }
    },
    handleRemove(file) {
      let activeIndex = 0
      this.imageList.map((item, index) => {
        if (item === file.name) {
          activeIndex = index
        }
      })
      this.imageList.splice(activeIndex, 1)
      this.designRuleForm.reqFileList.splice(activeIndex, 1)
    },
    // 超出
    handleExceed() {
      this.$message.warning('图片最多上传6张')
    },
    submitForm(type) {
      this.$refs['designRuleForm'].validate(valid => {
        if (valid) {
          let formObj = Object.assign({}, this.designRuleForm)

          formObj.province = this.designRuleForm.reqAddr[0]
          formObj.city = this.designRuleForm.reqAddr[1]
          formObj.district = this.designRuleForm.reqAddr[2]
          delete formObj.reqAddr

          formObj.servicesInclude = formObj.servicesInclude.join(',')

          type === 'save' ? (formObj.reqStatus = 0) : (formObj.reqStatus = 2)

          let reqUrl = ''
          if (this.isEdit) {
            formObj.reqEndtime =
              formObj.reqEndtime.length > 12
                ? formObj.reqEndtime
                : `${formObj.reqEndtime} 00:00:00`

            reqUrl = '/cms/reqDesign/updateReqDesign'
          } else {
            formObj.addUserGuid = this.userInfo.customerId
            reqUrl = '/cms/reqDesign/saveReqDesign'
          }

          this.$http.post(reqUrl, formObj).then(res => {
            if (res.data.code === '000000') {
              this.resetData()
              this.$refs.designRuleForm.resetFields()

              // 点击保存
              if (type === 'save') {
                this.$message({
                  type: 'success',
                  message: '保存成功',
                  onClose: () => {
                    if (this.isEdit) {
                      this.$router.push({
                        path: '/user/mineDemand'
                      })
                    }
                  }
                })
              } else {
                // 点击提交
                this.dialogVisible2 = true
              }
            }
          })
        } else {
          return false
        }
      })
    },

    resetData() {
      this.designRuleForm = {
        reqName: '', // 项目名称
        reqAddr: '', // 项目所在地
        address: '', // 详细地址
        reqEndtime: '', // 交付时间
        lightSteelStructureType: '', // 订单类型
        constructionSpace: '', // 建筑总面积
        designRequire: '', // 设计要求
        servicesInclude: [], // 包含服务
        reqFileList: [], // 图片/需求附件
        linkmanName: '', // 联系人
        linkmanMobile: '' // 联系人手机号
      }
    },

    toDemandHall() {
      this.dialogVisible2 = false
      if (this.isEdit) {
        this.$router.push({
          path: '/user/mineDemand'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.design-form {
  .lflex {
    position: relative;
    .unit {
      position: absolute;
      top: 10px;
      right: -20px;
    }
  }
  .upload-tips {
    font-size: 12px;
    color: #d01c26;
    line-height: 17px;
    margin-top: 6px;
  }
  .sub-btn {
    width: 150px;
    height: 36px;
    border-color: #ce2939;
    background: #ce2939;
    color: #ffffff;
  }
  .save-btn {
    background: #ffffff;
    color: #ce2939;
    margin-right: 30px;
    margin-left: 50px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #d01c26;
    border-color: #d01c26;
  }
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #d01c26;
  }
}
</style>
